// extracted by mini-css-extract-plugin
export default {"root":"LockerNew-root-c326"};